import React from "react";
import Wrapper from "../layout/Wrapper";
import BannerComp from "../components/BannerComp/BannerComp";
import WhyChooseSec from "../components/HomeSecComp/WhyChooseSec";
import ServiceComp from "../components/HomeSecComp/ServiceComp";
import ViewAllWorks from "../components/HomeSecComp/ViewAllWorks";
import DesignFutureSec from "../components/HomeSecComp/DesignFutureSec";
import assests from "../ui/assests";

export default function Home() {
  return (
    <Wrapper>
      <BannerComp
        className="banner_main"
        image={assests.bannerImg}
        title="- Let's Build the Web Together -"
        istagTitle="Your Vision, Our Design"
      />
      <WhyChooseSec />
      <ServiceComp />
      <ViewAllWorks />
      <DesignFutureSec />
    </Wrapper>
  );
}
